// import $ from 'jquery';
import React from 'react';
import Field from './Field';
import { isInt, isNumeric, isFloat, isEmpty } from 'validator';
import {getTranslation} from "../../lang/main";
// import PropTypes from 'prop-types';

class FieldNumber extends Field {
    constructor(props) {
        super(props);

        this.state = {
            fieldErrorMessage: '',
        };
    }
    componentDidMount() {
        // work around
        const { updateUserInput } = this.props;
        if (updateUserInput) {
            updateUserInput();
        }
    }
    formatStrict(value) {
        const { min, max } = this.props;
        // if (!value) return value;
        if (min !== false && Number(value) < min) {
            return min;
        } else if (max !== false && Number(value) > max) {
            return max;
        }
        return value;
    }
    format(value) {
        const {
            strict,
            allowDecimals,
            allowNegative,
            parseIntDisable,
        } = this.props;
        let newValue = value
            .replace(/[A-Za-z]/g, '')
            // replace the first decimal mark with reserved placeholder
            .replace('.', 'M')

            // strip non numeric letters except minus and "M"
            // this is to ensure prefix has been stripped
            .replace(/[^\dM-]/g, '')

            // replace the leading minus with reserved placeholder
            .replace(/^\-/, 'N')

            // strip the other minus sign (if present)
            .replace(/\-/g, '')

            // replace the minus sign (if present)
            .replace('N', allowNegative ? '-' : '')

            // strip the other dot sign (if present)
            .replace(/\./g, '')

            // replace decimal mark
            .replace('M', '.');

        const lastChar = newValue.charAt(newValue.length - 1);

        // allowDecimals
        if (!allowDecimals) {
            newValue = newValue.replace(/[^0-9-]/g, '');
        }

        // skip validation for now
        if (lastChar == '.' || lastChar == '-' || newValue == '') {
            return newValue;
        }

        // strict mode
        if (strict) {
            newValue = this.formatStrict(newValue);
        }

        if (parseIntDisable) {
            return newValue;
        }

        return Number(newValue);
    }
    validate() {
        const { value, min, max, allowDecimals } = this.props;
        let condition = true;
        let fieldErrorMessage = '';

        const check = allowDecimals ? isFloat : isInt ;

        if (String(value) != '') {
            if (min && max) {
                condition = check(String(value), {min: min, max: max});

                if (!condition) {
                    fieldErrorMessage = `${getTranslation('FIELD.VALUE_HAS_TO_BE')} ${getTranslation('FIELD.BETWEEN')} ${min} ${getTranslation('FIELD.AND')} ${max}`;
                }
            } else if (min) {
                condition = check(String(value), {gt: min - 1});

                if (!condition) {
                    fieldErrorMessage = `${getTranslation('FIELD.VALUE_HAS_TO_BE')} ${getTranslation('FIELD.AT_LEAST_THAN')} ${min}`;
                }
            } else if (max) {
                condition = check(String(value), {lt: max + 1});

                if (!condition) {
                    fieldErrorMessage = `${getTranslation('FIELD.VALUE_HAS_TO_BE')} ${max} ${getTranslation('FIELD.OR_LESS')}`;
                }
            }
        }

        this.setState({
            fieldErrorMessage,
        });

        return super.validate() && isNumeric(String(value)) && condition;
    }
    onKeyPress(e) {
        e.stopPropagation();
        // const { lastInput, lastValue } = this;
        const { value } = e.target;
        const charCode = e.which || e.keyCode;
        const charStr = String.fromCharCode(charCode);
        // const altKeys = e.ctrlKey || e.metaKey || e.altKey;

        // console.log(value, '  charStr:', charStr, '  lastInput:', this.lastInput, '   altkeys:', altKeys);

        // if (!value && !altKeys && !/[\d-]/.test(charStr)) {
        if (!value || !/[\d-]/.test(charStr)) {
            // console.log('prevent');
            // e.preventDefault();
        }
    }
    handleClasses() {
        return super.handleClasses();
    }
    // render
    renderError() {
        const { fieldErrorMessage } = this.state;
        if (fieldErrorMessage != '') {
            return (
                <span className='field__alert' style={{ display: 'block' }}>{fieldErrorMessage}</span>
            );
        }

        return super.renderError();
    }
    render() {
        const { min, max } = this.props;

        return (
            <label
                className={this.handleClasses()}
                data-label={super.renderAnimatedLabel()}
                ref={(r) => (this.field = r)}
            >
                {super.renderTooltip()}
                {super.renderLabel()}
                {super.renderAutoresize()}
                <input
                    className='field__input'
                    ref={(r) => (this.input = r)}
                    {...super.generateProps()}
                    type='text'
                    // type="number"
                    min={min}
                    max={max}
                />
                {this.renderError()}
                {super.renderLoading()}
            </label>
        );
    }
}

export default FieldNumber;
